import { GeoJson } from '@ais-ui/api-spec/shapes';
import React, { useCallback } from 'react';
import {
  DrawGeometryType,
  propagateGeometryChanges,
} from '@ais-ui/react-openlayers';
import { UseFormReturn } from 'react-hook-form';
import { createGeometryFromGeoJson } from '@ais-ui/utils';
import { GeometryTextEditorPopover } from './GeometryTextEditorPopover';

interface TextGeometryPopoverProps {
  form: UseFormReturn<any>;
  geometryType: DrawGeometryType;
  shape: GeoJson;
}

/**
 * TextGeometryPopover - Form-based wrapper for GeometryTextEditorPopover.
 *
 * Used in dialogs where shapes are created/edited via React Hook Form.
 * Updates the form's geometry field when the user submits new GeoJSON.
 */
export const TextGeometryPopover = ({
  form,
  geometryType,
  shape,
}: TextGeometryPopoverProps) => {
  const handleApply = useCallback(
    (newShape: GeoJson) => {
      const geometry = createGeometryFromGeoJson(newShape);
      propagateGeometryChanges(geometry, 'geometry', form);
    },
    [form],
  );

  return (
    <GeometryTextEditorPopover
      geometryType={geometryType}
      shape={shape}
      onApply={handleApply}
      buttonSize="icon"
      buttonVariant="outline"
      buttonClassName="size-10"
      popoverSide="left"
    />
  );
};
